import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { MOTIVE, MOTIVE_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetMotive,
    asyncGetMotiveHistorical,
    asyncPatchMotiveParam,
    asyncPostMotiveParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { ISelect } from '../../../../../shared/types/shared';
import { Motive } from '../../../../../shared/types/systemConfiguration/motives';
import { AlertsHistorical } from '../../../../../shared/types/legalProceedings/alerts';

export const useMotiveForm = () => {
    const navigate = useNavigate();
    const { name, active } = useParams();
    const [motive, setMotive] = useState<Motive>();
    const [loading, setLoading] = useState(false);
    const [formikMotiveData, setFormikMotiveData] =
        useState<FormikProps<Motive>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [motiveHistorical, setMotiveHistorical] =
        useState<AlertsHistorical[]>();

    const isValidForm = formikMotiveData?.isValid;

    const handleCleanAndBack = () => {
        formikMotiveData?.resetForm();
        navigate(MOTIVE);
    };

    const handleSubmit = async () => {
        await formikMotiveData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Motive = formikMotiveData?.values;

        let res: any | undefined = undefined;

        try {
            if (motive && motive.id)
                res = await asyncPatchMotiveParam(motive.id, active, data);
            else res = await asyncPostMotiveParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el motivo se ${
                    motive && motive.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(
                `${MOTIVE_DETAIL}/${encodeURIComponent(item.name)}/${
                    item.active
                }`
            );
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    motive && motive.id ? 'actualizar' : 'crear'
                } el motivo. Por favor, asegúrate de ${
                    motive && motive.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(name)) {
            setLoading(true);
            asyncGetMotive(name, active)
                .then((motive: any) => {
                    if (!motive || !motive.items) navigate(MOTIVE);

                    [motive?.parent].forEach((item: any) => {
                        if (item)
                            Object.keys(item).forEach((key) => {
                                if (item?.[key] && (item?.[key] as ISelect)?.id)
                                    item[key] = (
                                        item[key] as ISelect
                                    )?.id.toString();
                            });
                    });

                    setMotive(motive?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [name]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetMotiveHistorical(name, active)
                .then((resp) => {
                    if (resp) setMotiveHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        motive,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikMotiveData,
        motiveHistorical,
        showHistorical,
        setShowHistorical,
    };
};
